import { render, staticRenderFns } from "./turnplate.vue?vue&type=template&id=4a7818f2&scoped=true&"
import script from "./turnplate.vue?vue&type=script&lang=js&"
export * from "./turnplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7818f2",
  null
  
)

export default component.exports